export default "__VITE_ASSET__BLUz9XDM__"